import { useAppDispatch } from '@hooks/redux';
import { createCounterpartyApi } from '@http/counterparties';
import { Button, Divider, Input, Form } from 'antd';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const ResidentsForm = () => {
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const submit = (values: any) => {
    dispatch(createCounterpartyApi({ ...values, counterparty_type: 'RESIDENT' })).then(data => {
      if (data) {
        navigate('/counterparties');
      }
    });
  };

  return (
    <Form form={form} name='OwnAccounts' onFinish={submit}>
      <div className='mt-3'>
        <p className='text-base color-active font-semibold mb-4'>{t('Основная информация')}</p>

        <div className='md:grid grid-cols-5'>
          <p className='col-span-1 text-bs color-title'>{t('Name')}:</p>
          <div className='col-span-2'>
            <Form.Item className='m-0' name='title' rules={[{ required: true, message: `${t('Required')}` }]}>
              <Input style={{ width: '100%' }} size='large' />
            </Form.Item>
          </div>
        </div>

        <div className='md:grid grid-cols-5 mt-7'>
          <p className='col-span-1 text-bs color-title'>{t('TIN')}:</p>
          <div className='col-span-2'>
            <Form.Item
              className='m-0'
              name='tax_id'
              rules={[
                {
                  pattern: /^[0-9]+$/,
                  message: `${t('Enter number only')}`,
                },
                {
                  min: 9,
                  message: `${t('Must be 9 numbers')}`,
                },
              ]}
            >
              <Input maxLength={9} minLength={9} style={{ width: '100%' }} size='large' />
            </Form.Item>
          </div>
        </div>

        <Divider />
        <p className='text-base color-active font-semibold mb-4'>{t('Account')}</p>

        <div className='md:grid grid-cols-5 mt-7'>
          <p className='col-span-1 text-bs color-title'>{t('Account number')}:</p>
          <div className='col-span-2'>
            <Form.Item
              className='m-0'
              name='receiving_ac'
              rules={[
                { required: true, message: `${t('Required')}` },
                {
                  pattern: /^[0-9]+$/,
                  message: `${t('Enter number only')}`,
                },
              ]}
            >
              <Input style={{ width: '100%' }} size='large' />
            </Form.Item>
          </div>
        </div>

        <div className='md:grid grid-cols-5 mt-7'>
          <p className='col-span-1 text-bs color-title'>{t('BIC')}:</p>
          <div className='col-span-2'>
            <Form.Item
              className='m-0'
              name='bank_code'
              rules={[
                {
                  pattern: /^[0-9]+$/,
                  message: `${t('Enter number only')}`,
                },
                {
                  min: 9,
                  message: `${t('Must be 9 numbers')}`,
                },
              ]}
            >
              <Input style={{ width: '100%' }} size='large' />
            </Form.Item>
          </div>
        </div>

        <Divider />
        <p className='text-base color-active font-semibold mb-4'>{t('Contacts')}</p>

        <div className='md:grid grid-cols-5 mt-7'>
          <p className='col-span-1 text-bs color-title'>{t('Phone number')}:</p>
          <div className='col-span-2'>
            <Form.Item className='m-0' name='phone_number'>
              <Input style={{ width: '100%' }} size='large' />
            </Form.Item>
          </div>
        </div>

        <div className='md:grid grid-cols-5 mt-7'>
          <p className='col-span-1 text-bs color-title'>{t('Email')}:</p>
          <div className='col-span-2'>
            <Form.Item className='m-0' name='email'>
              <Input style={{ width: '100%' }} size='large' />
            </Form.Item>
          </div>
        </div>

        <div className='md:grid grid-cols-5 mt-7'>
          <div className='col-span-3 flex justify-end'>
            <Button type='primary' size='middle' htmlType='submit'>
              {t('Confirm')}
            </Button>
          </div>
        </div>
      </div>
    </Form>
  );
};

export default ResidentsForm;
